import React, { useState } from "react";

const getInitial = (name) =>
  name?.charAt(0)?.toUpperCase() || "?";

const formatTime = (date) => {
  if (!date) return "";

  const d = date.toDate ? date.toDate() : new Date(date);
  const diff = (Date.now() - d.getTime()) / 1000;

  if (diff < 60) return "now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;

  return d.toLocaleDateString();
};

const ConversationList = ({
  conversations = [],
  userMap = {},
  onSelect,
  currentEmail,
  selectedChat,
  title = "Inbox",
}) => {
  const [search, setSearch] = useState("");

const filtered = conversations.filter((c) => {
  const email =
    c.providerId === currentEmail
      ? c.userId
      : c.providerId;

  const user = userMap[email] ?? {
    email,
    name: email,
    headshotURL: "",
  };

  return user.name
    .toLowerCase()
    .includes(search.toLowerCase());
});

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          padding: "14px 16px",
          fontSize: "18px",
          fontWeight: "600",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        {title}
      </div>

      {/* SEARCH */}
      <div
        style={{
          padding: "12px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <input
          placeholder="Search by name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: "100%",
            height: "38px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            padding: "0 12px",
            boxSizing: "border-box",
            outline: "none" 
          }}
        />
      </div>

      {/* CONVERSATION LIST */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
        }}
      >
        {filtered.length === 0 ? (
          <div
            style={{
              padding: "30px",
              textAlign: "center",
              color: "#888",
            }}
          >
            No conversations found.
          </div>
        ) : (
          filtered.map((conv) => {
            const email =
  conv.providerId === currentEmail
    ? conv.userId
    : conv.providerId;

            const user = userMap[email] ?? {
              email,
              name: email,
              headshotURL: "",
            };

            const isActive =
              selectedChat?.id === conv.id;

            const unread =
  conv.providerId === currentEmail
    ? conv.unreadCountProvider || 0
    : conv.unreadCountUser || 0;

            return (
              <div
                key={conv.id}
                onClick={() => onSelect(conv)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px 16px",
                  cursor: "pointer",
                  background: isActive
                    ? "#e6f0ff"
                    : "#fff",
                  borderBottom:
                    "1px solid #f0f0f0",
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background =
                      "#f8f9fa";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background =
                      "#fff";
                  }
                }}
              >
                {/* AVATAR */}
                {user.headshotURL ? (
                  <img
                    src={user.headshotURL}
                    alt={user.name}
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "50%",
                      background: "#0078ff",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "600",
                      flexShrink: 0,
                    }}
                  >
                    {getInitial(user.name)}
                  </div>
                )}

                {/* CONTENT */}
                <div
                  style={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        "space-between",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "6px",
    overflow: "hidden",
  }}
>
  

  <div
    style={{
      fontWeight:
        unread > 0
          ? "600"
          : "500",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {user.name}
  </div>
  {conv.urgent && (
    <span
      title="Urgent"
      style={{
        color: "#dc3545",
        fontSize: "16px",
        flexShrink: 0,
      }}
    >
      ❗
    </span>
  )}
</div>

                    <span
                      style={{
                        fontSize: "11px",
                        color: "#888",
                        flexShrink: 0,
                      }}
                    >
                      {formatTime(
                        conv.lastMessageAt
                      )}
                    </span>
                  </div>

                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "4px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span><b>{conv.subject || ""}</b></span> <br />
                    {conv.lastMessage || ""}
                  </div>
                </div>

                {/* UNREAD BADGE */}
                {unread > 0 && (
                  <div
                    style={{
                      background: "#0078ff",
                      color: "#fff",
                      borderRadius: "12px",
                      minWidth: "22px",
                      height: "22px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0 6px",
                      fontSize: "11px",
                      fontWeight: "600",
                      flexShrink: 0,
                    }}
                  >
                    {unread}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ConversationList;